import { render, staticRenderFns } from "./gettingStarted.vue?vue&type=template&id=56caae58"
import script from "./gettingStarted.vue?vue&type=script&lang=js"
export * from "./gettingStarted.vue?vue&type=script&lang=js"
import style0 from "./gettingStarted.vue?vue&type=style&index=0&id=56caae58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports